<template>
    <div class="main">
        <c-panel title="Relatórios executados" titleIcon="fas fa-file-export">
            <!--
              FASE 4 / AF-2 — DOC 59: "Permitir integrações com relatórios executados".

              POR QUE UMA TELA CENTRAL, E NÃO UM BOTÃO EM CADA RELATÓRIO

              São 91 telas que executam relatório. Um botão em cada uma resolveria as 91 de
              hoje e deixaria a 92ª de fora — e um relatório novo nasceria sem integração, que
              é exatamente o padrão de falso COMPLETO que estas auditorias vêm encontrando.

              Aqui a lista vem do REGISTRO de execução (`impressoes_html`), alimentado por dois
              caminhos que toda tela de relatório já percorre:

                o registro nativo do `PdfService`             22 telas
                o registro por rota (interceptor + event bus) as demais

              Relatório novo aparece sozinho, sem ninguém alterar tela nenhuma.

              CORREÇÃO DE UMA CONCLUSÃO ANTERIOR

              A primeira versão desta tela cobria só as 22 do registro nativo, e o relatório de
              fechamento do AF-2 tratou as demais como "fora do alcance do DOC 59" porque suas
              rotas são públicas. Aquilo estava errado: o edital pede "relatórios executados",
              sem qualificar, e uma limitação de arquitetura não redefine o requisito.
            -->
            <el-alert type="info" :closable="false" show-icon class="u-mb-15"
                      title="Execute um relatório e ele aparece aqui"
                      description="Cada relatório que você gera fica disponível para ser arquivado no acervo de Documentos. Alguns ficam disponíveis por 15 minutos — passado esse prazo, basta gerá-los de novo.">
            </el-alert>

            <el-row class="u-mb-10">
                <el-col :xs="24" class="u-text-right">
                    <el-button size="small" icon="el-icon-refresh" @click="carregar">ATUALIZAR</el-button>
                </el-col>
            </el-row>

            <div v-loading="carregando">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Relatório</th>
                            <th class="hidden-xs-only" style="width:170px">Executado em</th>
                            <th style="width:150px">Situação</th>
                            <th style="width:210px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="e in execucoes" :key="e.execucao_id">
                            <td>{{ e.relatorio }}</td>
                            <td class="hidden-xs-only">{{ e.executado_em | dataHora }}</td>
                            <td>
                                <el-tag size="mini" type="success" v-if="e.documento_id">arquivado</el-tag>
                                <el-tag size="mini" type="info" v-else-if="e.expirado">expirado</el-tag>
                                <el-tag size="mini" type="warning" v-else>disponível</el-tag>
                            </td>
                            <td class="u-text-right">
                                <el-button v-if="e.arquivavel" type="primary" size="mini"
                                           icon="el-icon-folder-add" :loading="arquivando === e.execucao_id"
                                           @click="arquivar(e)">ARQUIVAR</el-button>

                                <el-button class="u-ml-10" v-if="e.documento_id" size="mini" plain icon="el-icon-view"
                                           @click="abrir(e.documento_id)">ABRIR DOCUMENTO</el-button>

                                <small class="u-text-muted" v-if="e.expirado && !e.documento_id">
                                    gere o relatório novamente
                                </small>
                            </td>
                        </tr>
                        <tr v-if="!execucoes.length && !carregando">
                            <td colspan="4" class="u-text-center u-text-muted">
                                Nenhum relatório executado por você ainda.
                                Gere um relatório em qualquer módulo e volte aqui.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    filters: {
        dataHora (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—' }
    },
    data: () => ({
        execucoes: [],
        carregando: false,
        arquivando: null
    }),
    components: { cPanel: () => import('@/shared/c-panel/c-panel.vue') },
    mounted () { this.carregar() },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        carregar () {
            this.carregando = true

            this.$axios.post(`${this.base()}/api/documento-integracao/relatorios-executados`,
                { limite: 50 }, this.auth()
            ).then(r => {
                this.execucoes = r.data || []
                this.carregando = false
            }).catch(e => {
                this.carregando = false
                this.execucoes = []

                if (e.response && e.response.status !== 403) {
                    this.$message.error('Não foi possível carregar os relatórios executados.')
                }
            })
        },

        arquivar (e) {
            this.arquivando = e.execucao_id

            this.$axios.post(`${this.base()}/api/documento-integracao/arquivar-relatorio`,
                { token: e.token, titulo: 'Relatório ' + e.relatorio }, this.auth()
            ).then(r => {
                this.arquivando = null
                this.$message.success('Relatório arquivado em Documentos.')
                this.carregar()

                this.$confirm('Deseja abrir o documento agora?', 'Arquivado',
                    { confirmButtonText: 'ABRIR', cancelButtonText: 'FICAR AQUI', type: 'success' }
                ).then(() => this.abrir(r.data.documento_id)).catch(() => {})
            }).catch(err => {
                this.arquivando = null

                this.$message.error((err.response && err.response.data && err.response.data.message)
                    || 'Não foi possível arquivar este relatório.')

                this.carregar()
            })
        },

        abrir (id) { this.$router.push(`/admin/documento/detalhe/${id}`) }
    }
}
</script>
